var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { Field, reduxForm } from "redux-form";
import { defineMessages, FormattedMessage } from "react-intl";
import loadingImage from "../../assets/img/loading.gif";
var required = function (value) { return (value ? undefined : "Required"); };
var renderField = function (_a) {
    var input = _a.input, type = _a.type, value = _a.value, _b = _a.meta, touched = _b.touched, error = _b.error;
    var inputCls = touched && error ? "recharge-error" : "";
    var styleForError = {
        minWidth: "151px",
        width: "56%",
        margin: "0 22%",
        textAlign: "center"
    };
    var messages = defineMessages({
        join_error_incorrect_code: {
            id: "confirmation.code_incorrect",
            defaultMessage: "Код указан неверно"
        }
    });
    return (_jsxs("div", __assign({ className: "input" }, { children: [_jsx("input", __assign({ style: { textTransform: "uppercase", textAlign: "center" } }, input, { type: type, className: inputCls, defaultValue: value })), touched &&
                error && (_jsx("div", __assign({ className: "error-wrapper", style: styleForError }, { children: _jsx("div", __assign({ className: "important" }, { children: _jsx(FormattedMessage, __assign({}, messages.join_error_incorrect_code)) })) })))] })));
};
var SmsCodeModal = function (props) {
    var profile = props.profile, close = props.close, submitAction = props.submitAction, showModal = props.showModal, loading = props.loading;
    var createConfirmStatus = profile.createConfirmStatus;
    var messages = defineMessages({
        join_placeholder: {
            id: "join.fast.phone_confirm.confirmation_code",
            defineMessage: "Код подтверждения"
        },
        confirm: {
            id: "confirmation.confirm",
            defineMessage: "Подтвердить"
        }
    });
    useEffect(function () {
        if (showModal) {
            document.body.setAttribute("style", "overflow: hidden");
            document.documentElement.setAttribute("style", "overflow: hidden");
        }
        return function () {
            document.body.removeAttribute("style");
            document.documentElement.removeAttribute("style");
        };
    }, [showModal, createConfirmStatus]);
    return (_jsx(Modal, __assign({ className: "modal", id: "modalLogin", bsSize: "large", show: createConfirmStatus === 0 && showModal, onHide: close }, { children: _jsx("div", __assign({ className: "body" }, { children: _jsx("div", __assign({ className: "signin" }, { children: _jsxs("form", __assign({ id: "phone-check-form", onSubmit: submitAction }, { children: [_jsx("div", __assign({ className: "input" }, { children: _jsxs("h4", { children: [" ", _jsx(FormattedMessage, __assign({}, messages.join_placeholder))] }) })), _jsx(Field, { type: "text", component: renderField, name: "code", validate: [required] }), _jsx("div", __assign({ className: "controls" }, { children: _jsx("button", __assign({ type: "submit", disabled: loading }, { children: loading ? (_jsx("img", { src: loadingImage, alt: "loading", style: { opacity: 0.3 } })) : (_jsx(FormattedMessage, __assign({}, messages.confirm))) })) }))] })) })) })) })));
};
SmsCodeModal.propTypes = {
    submitAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.any.isRequired,
    close: PropTypes.any.isRequired,
    profile: PropTypes.object.isRequired,
    showModal: PropTypes.bool.isRequired
};
SmsCodeModal = reduxForm({
    form: "phone-confirm"
})(SmsCodeModal);
export default SmsCodeModal;



// WEBPACK FOOTER //
// ./src/components/shared/PhoneConfirmationModal.jsx